(function () {
  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event.cartData;
      if (!cart || !cart.items) return;

      // Build a set of all non-gift variant IDs currently in the cart
      const mainVariantIds = new Set(
        cart.items
          .filter((item) => !(item.properties && item.properties['_regalo'] === 'true'))
          .map((item) => String(item.variant_id))
      );

      // Find gift items whose triggering variant is no longer in the cart
      const orphanedGifts = cart.items.filter(
        (item) =>
          item.properties &&
          item.properties['_regalo'] === 'true' &&
          !mainVariantIds.has(String(item.properties['_regalo_para']))
      );

      if (orphanedGifts.length === 0) return;

      // Simulate a remove button click for each orphaned gift so that
      // Dawn's CartDrawerItems handles the full removal + re-render natively.
      // CartDrawerItems already updated the DOM to show the gift before publishing
      // cartUpdate, so the remove button is present and clickable.
      for (const gift of orphanedGifts) {
        const removeBtn = document.querySelector(
          `.cart-remove-button[data-variant-id="${gift.variant_id}"]`
        );
        if (removeBtn) {
          removeBtn.click();
          break; // One at a time; the next cartUpdate will catch any remaining orphans
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
